import { Center, Spinner } from "@chakra-ui/react"
import PanelSection from "@pathwright/ux/src/components/augmentation/AugmentationPanelSection"
import { useCoverPageContext } from "../CoverPageProvider"
import { useCoverPageIsEditable } from "../access"
import { CoverPagePanelSectionKey } from "../types"
import { useCoverPageHasLoadedResource } from "../useCoverPageHasLoadedResource"
import { CoverPagePanelCategoriesSection } from "./CoverPagePanelCategories"
import { CoverPagePanelContributorsSection } from "./CoverPagePanelContributors"
import { CoverPagePanelOffersSection } from "./CoverPagePanelOffers"
import { CoverPagePanelPitchSection } from "./CoverPagePanelPitch"

export type CoverPagePanelSection = {
  sectionKey: CoverPagePanelSectionKey
  label: string
  heading: string
  triggerLabel: string
}

export function CoverPagePanelHome() {
  const resourceId = useCoverPageContext((v) => v.resourceId)
  const offersAreReady = useCoverPageContext((v) => v.offersAreReady)
  const hasLoadedResource = useCoverPageHasLoadedResource()
  const isEditable = useCoverPageIsEditable()

  if (!hasLoadedResource || !offersAreReady) {
    return (
      <Center w="full" py={8}>
        <Spinner />
      </Center>
    )
  }
  if (!isEditable) return <></>

  return (
    <PanelSection.Group key={resourceId}>
      <CoverPagePanelPitchSection />
      <CoverPagePanelOffersSection />
      <CoverPagePanelContributorsSection />
      <CoverPagePanelCategoriesSection />
    </PanelSection.Group>
  )
}
